export const FINANCIAL_INSIGHTS_LANDING_PAGE_SCHEMA = {
  en: {
    review_section: {
      heading: "What clarity feels like",
      description:
        "See how people are using Financial Insights to better understand their money.",
      cta_rev: "Start Free",
    },
    closing_page: {
      heading: "Your money isn’t just moving. It’s telling you something.",
      description:
        "Financial Insights connects the dots across your transactions, spending, budgets, and recurring payments — so you can understand what’s shaping your financial life.",
      ctas: [
        { text: "Start Free", link: "/sign-up" },
        { text: "Log In", link: "/sign-in" },
      ],
    },
  },
};
